import { render, staticRenderFns } from "./KategoriPenyaluranDana.vue?vue&type=template&id=52ea10f2"
import script from "./KategoriPenyaluranDana.vue?vue&type=script&lang=js"
export * from "./KategoriPenyaluranDana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports